import React from 'react';
import PropTypes from 'prop-types';
import VerbHeading from '../../../shared/components/VerbHeading';
import VerbParagraph from '../../../shared/components/VerbParagraph';
import CollectionSlider from '../../components/widgets/CollectionSlider';

export default function UserCollectionsDiscoverRow({
    userCollections,
    loading,
    headingMessageId,
    defaultHeadingMessage,
    subTextId,
    defaultSubTextMessage,
    handleRecommendationModalOpen,
    onCardClick,
    addons
}) {
    return (
        <div className={'collection-row home-in-progress-collections'}>
            <div className={'container'}>
                <VerbHeading hNumber={5} messageId={headingMessageId} defaultMessage={defaultHeadingMessage} />
                <VerbParagraph
                    className={'category-subtext'}
                    defaultMessage={defaultSubTextMessage}
                    messageId={subTextId}
                />
                <div className={'row'}>
                    <CollectionSlider
                        handleRecommendationModalOpen={handleRecommendationModalOpen}
                        onCardClick={onCardClick}
                        cardOrientation={'vertical'}
                        userCollections={userCollections}
                        loading={loading}
                        cardClassName={'col-12'}
                        className={'vertical-cards'}
                        addons={addons}
                    />
                </div>
            </div>
        </div>
    );
}

UserCollectionsDiscoverRow.propTypes = {
    userCollections: PropTypes.array,
    loading: PropTypes.bool,
    headingMessageId: PropTypes.string,
    defaultHeadingMessage: PropTypes.string,
    subTextId: PropTypes.string,
    defaultSubTextMessage: PropTypes.string,
    handleRecommendationModalOpen: PropTypes.func,
    onCardClick: PropTypes.func,
    addons: PropTypes.array
};
